export default {
    message: {
        calculator: {
            btn1_link: "/en-gb/products/citrix-workspace/form/pricing-inquiry/",
        }
    }
}